import { useEffect, useRef } from "react";
import { useInView, animate } from "framer-motion";
import Reveal, { Eyebrow } from "./Reveal";
import { STATS } from "../data/siteData";

function Counter({ value, prefix = "", suffix = "", unit = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  useEffect(() => {
    if (!inView || !ref.current) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = `${prefix}${Math.round(v)}${suffix}${unit}`;
      },
    });
    return () => controls.stop();
  }, [inView, value, prefix, suffix, unit]);
  return <span ref={ref}>{`${prefix}0${suffix}${unit}`}</span>;
}

export default function StatsBar() {
  return (
    <section data-testid="stats-bar" className="relative py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="glass rounded-3xl px-6 py-10 sm:px-10">
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-5">
            {STATS.map((s, i) => (
              <div key={s.label} data-testid={s.testId} className="text-center">
                <p className="font-display text-3xl font-extrabold tracking-tight text-brand-navy sm:text-4xl">
                  <Counter value={s.value} prefix={s.prefix || ""} suffix={s.suffix} unit={s.unit || ""} />
                </p>
                <p className="mt-1.5 text-xs font-medium uppercase tracking-wider text-brand-gray sm:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function SectionHead({ eyebrow, title, sub, center = false }) {
  return (
    <Reveal className={`mb-12 max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl">{title}</h2>
      {sub && <p className="mt-4 text-base leading-relaxed text-brand-gray sm:text-lg">{sub}</p>}
    </Reveal>
  );
}
